export function toEuro (value) {
  return Number(value)
    .toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2
    })
}
export function toProperDate (value) {
  let months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May', 'Jun.', 'Jul.', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.']
  let month = Number(value.split('-')[0]) - 1
  let year = value.split('-')[1]
  return `${months[month]} ${year}`
}

export function capitalize (value) {
  return value[0].toUpperCase() + value.slice(1)
}

export function dashToDotsDateFormat (date) {
  if (date) { // check if actually date passed from view
    return date.split(' ')[0].split('-').reverse().reduce((acc, item) => { // split date items by '-' and get array
      acc += `${item}.` // for each available data item add it to sting with dot
      return acc
    }, '').slice(0, -1) // remove last element of string (extra dot)
  }
}
